import {
  FeatureFlagDto,
  FeatureFlagPayload,
  FeatureFlagWire,
  fromWire,
} from "../types/featureFlag.definition";
import {
  requestCreateFeatureFlag,
  requestDeleteFeatureFlag,
  requestGetFeatureFlags,
  requestUpdateFeatureFlag,
} from "../webclients/featureFlag.client";

export const featureFlagApi = {
  getFeatureFlags: async (): Promise<FeatureFlagDto[]> => {
    const response = await requestGetFeatureFlags();
    const wireList = (response.data ?? []) as FeatureFlagWire[];
    return wireList.map(fromWire);
  },

  createFeatureFlag: async (
    data: FeatureFlagPayload
  ): Promise<FeatureFlagDto> => {
    const response = await requestCreateFeatureFlag(data);
    return fromWire(response.data as FeatureFlagWire);
  },

  updateFeatureFlag: async (
    id: number,
    data: FeatureFlagPayload
  ): Promise<FeatureFlagDto> => {
    const response = await requestUpdateFeatureFlag(id, data);
    return fromWire(response.data as FeatureFlagWire);
  },

  deleteFeatureFlag: async (id: number): Promise<void> => {
    await requestDeleteFeatureFlag(id);
  },
};
